import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Menu, X } from 'lucide-react';

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled 
          ? 'bg-white/95 backdrop-blur-md shadow-md py-3' 
          : 'bg-transparent py-5'
      }`}
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div 
            className="flex items-center cursor-pointer group"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          >
            <img 
              src="/logo.png" 
              alt="Assetree - Rooted in Real Estate Excellence" 
              className={`h-10 md:h-12 w-auto transition-all ${
                isScrolled ? 'brightness-100' : 'brightness-0 invert'
              }`}
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('about')}
              className={`text-sm font-medium transition-colors hover:text-gold ${
                isScrolled ? 'text-charcoal' : 'text-white'
              }`}
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('projects')}
              className={`text-sm font-medium transition-colors hover:text-gold ${
                isScrolled ? 'text-charcoal' : 'text-white'
              }`}
            >
              Projects
            </button>
            <button
              onClick={() => scrollToSection('why-choose')}
              className={`text-sm font-medium transition-colors hover:text-gold ${
                isScrolled ? 'text-charcoal' : 'text-white'
              }`}
            >
              Why Choose Us
            </button>
            <button
              onClick={() => scrollToSection('faq')}
              className={`text-sm font-medium transition-colors hover:text-gold ${
                isScrolled ? 'text-charcoal' : 'text-white'
              }`}
            >
              FAQ
            </button>
            <Button
              onClick={() => scrollToSection('contact')}
              className="bg-gold hover:bg-gold-600 text-navy px-6 font-semibold"
            >
              Contact Us
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`md:hidden p-2 transition-colors ${
              isScrolled ? 'text-charcoal' : 'text-white'
            }`}
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <nav className="md:hidden mt-4 pb-4 space-y-3 border-t border-gray-200 pt-4">
            <button
              onClick={() => scrollToSection('about')}
              className="block w-full text-left px-4 py-2 text-sm font-medium text-charcoal hover:bg-gray-100 rounded-md transition-colors"
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('projects')}
              className="block w-full text-left px-4 py-2 text-sm font-medium text-charcoal hover:bg-gray-100 rounded-md transition-colors"
            >
              Projects
            </button>
            <button
              onClick={() => scrollToSection('why-choose')}
              className="block w-full text-left px-4 py-2 text-sm font-medium text-charcoal hover:bg-gray-100 rounded-md transition-colors"
            >
              Why Choose Us
            </button>
            <button
              onClick={() => scrollToSection('faq')}
              className="block w-full text-left px-4 py-2 text-sm font-medium text-charcoal hover:bg-gray-100 rounded-md transition-colors"
            >
              FAQ
            </button>
            <Button
              onClick={() => scrollToSection('contact')}
              className="w-full bg-gold hover:bg-gold-600 text-navy font-semibold"
            >
              Contact Us
            </Button>
          </nav>
        )}
      </div>
    </header>
  );
};
